import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import './Header.css';

function Header() {
    const containerVariants = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.15,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: 'easeOut' },
        },
    };

    const logoVariants = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { duration: 0.8, ease: 'easeOut' },
        },
    };

    // Subtle + safe animation (no weird layout shifts)
    const fancyTextVariants = {
        hidden: { opacity: 0, y: 6 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: 'easeOut' },
        },
    };

    const handleScrollToContact = () => {
        const element = document.getElementById('contact-us');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    return (
        <section className="header-wrapper" id="home">
            <header className="header-modern">
                <motion.div
                    className="header-inner"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {/* LEFT CONTENT */}
                    <div className="header-left">
                        <motion.h1 variants={itemVariants}>
                            Dubai&apos;s Leading <br />
                            <span>Waste Collection Partner</span>
                        </motion.h1>

                        <motion.p
                            className="header-description"
                            variants={itemVariants}
                        >
                            <strong>Waste Problems?</strong> Consider Them{' '}
                            <motion.span
                                className="fancy-text"
                                variants={fancyTextVariants}
                                initial="hidden"
                                animate="visible"
                            >
                                Clean&nbsp;Swept
                            </motion.span>
                            .
                            <br />
                            Your reliable partner for seamless waste management
                            and disposal.
                        </motion.p>

                        <motion.div
                            className="header-actions"
                            variants={itemVariants}
                        >
                            <button
                                className="cta-button"
                                onClick={handleScrollToContact}
                            >
                                Get a Free Quote <ArrowRight size={20} />
                            </button>

                            <div className="trust-badge">
                                <Check size={18} />
                                <span>Dubai Municipality Approved</span>
                            </div>
                        </motion.div>
                    </div>

                    {/* RIGHT LOGO */}
                    <motion.div
                        className="header-right"
                        variants={logoVariants}
                    >
                        <div className="logo-glow" />
                        <img
                            src="/logo.png"
                            alt="CleanSweep Waste Management Dubai Logo"
                            className="header-logo"
                        />
                    </motion.div>
                </motion.div>
            </header>
        </section>
    );
}

export default Header;
